// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"190":"c4809976","336":"096d7e43"}[chunkId] + ".css";
};